import React from 'react'
import './articles.css'

const UBO = () => {
  return (
    <div className="articlecontainer">
      <header className="article-header">
        <h1>How to Register the Ultimate Beneficial Owner (UBO) in Albania</h1>
        <p>If you are setting up a company in Albania, registering the <strong>Ultimate Beneficial Owner (UBO)</strong> is a mandatory legal step for all business entities except sole proprietors. UBO registration ensures transparency in business ownership and helps prevent financial crimes like money laundering and tax evasion.</p>
        <p><strong>Failure to register a UBO within 30 days</strong> of company formation can result in fines of up to <strong>600,000 ALL (€6,000)</strong>. This guide explains who needs to register, required documents, and how to apply.</p>
      </header>

      <section className="step">
        <h2>What is a UBO and Who Needs to Register?</h2>
        <p>The <strong>Ultimate Beneficial Owner (UBO)</strong> is the individual who ultimately owns or controls a company, even if it is legally registered under another entity or person.</p>

        <h3>Who Must Register a UBO?</h3>
        <ul>
          <li>Limited Liability Companies (LLCs)</li>
          <li>Joint Stock Companies (JSCs)</li>
          <li>Partnerships and Foreign Company Branches</li>
        </ul>

        <h3>Who is Exempt from UBO Registration?</h3>
        <ul>
          <li>Sole Proprietors (Natural Persons/Individual Entrepreneurs) do not need to register a UBO.</li>
        </ul>
      </section>

      <section className="step">
        <h2>Step-by-Step Guide to Registering a UBO in Albania</h2>

        <h3>Step 1: Obtain an Electronic Signature</h3>
        <p>Since UBO registration is done online, the company administrator must first apply for an <strong>electronic signature</strong> via <strong>e-Albania</strong>.</p>
        <ul>
          <li>Go to <strong>e-Albania</strong> and select "Apply for Electronic Signature".</li>
          <li>Pay the required fee: <strong>4,800 ALL</strong>.</li>
          <li>Processing time: <strong>up to 10 working days</strong>.</li>
          <li>The electronic signature is valid for <strong>one year</strong> and must be renewed annually.</li>
        </ul>

        <h3>Step 2: Register the Ultimate Beneficial Owner (UBO)</h3>
        <p>The UBO registration must be completed within <strong>30 days</strong> of company formation via <strong>e-Albania</strong>.</p>

        <h4>Documents Needed for UBO Registration:</h4>
        <ul>
          <li>Company’s <strong>NIPT/NUIS number</strong> (Business Registration Number).</li>
          <li><strong>Company Registration Extract</strong> (available from the National Business Center - QKB).</li>
          <li><strong>Administrator’s Electronic Signature</strong> (required for application submission).</li>
          <li><strong>UBO Details</strong> (Full name, date of birth, nationality, percentage of ownership, method of control).</li>
        </ul>

        <h4>How to Apply for UBO Registration:</h4>
        <ol>
          <li>Log in to <strong>e-Albania</strong> using your electronic signature.</li>
          <li>Navigate to "<strong>Register Ultimate Beneficial Owner</strong>".</li>
          <li>Fill in the required details about the UBO(s).</li>
          <li>Upload the necessary documents.</li>
          <li>Submit the application for review.</li>
        </ol>
        <p><strong>Processing Time:</strong> The registration is usually approved within <strong>24-48 hours</strong>.</p>
      </section>

      <section className="step">
        <h2>Penalties for Non-Compliance</h2>
        <p>Failure to register the UBO within <strong>30 days</strong> of company formation can result in:</p>
        <ul>
          <li><strong>Fines up to 600,000 ALL (€6,000).</strong></li>
          <li>Additional penalties for <strong>false or incomplete information</strong>.</li>
        </ul>
        <p>To avoid legal issues, businesses should complete the registration as soon as possible after obtaining the electronic signature.</p>
      </section>

      <footer className="article-footer">
        <p><strong>Final Thoughts:</strong> UBO registration is a crucial step for business transparency in Albania. Since the process is fully online, having an <strong>electronic signature</strong> is mandatory for company administrators.</p>
        <p><strong>Key Takeaways:</strong></p>
        <ul>
          <li>UBO registration is <strong>mandatory</strong> for all business structures except sole proprietors.</li>
          <li>Registration must be completed within <strong>30 days</strong> of business formation.</li>
          <li>An <strong>electronic signature</strong> is required for submission via e-Albania.</li>
          <li>Failure to comply may result in <strong>fines up to 600,000 ALL</strong>.</li>
        </ul>
      </footer>
    </div>
  )
}

export default UBO